/**
 * News configuration
 */
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
        .state('news', {
            abstract: true,
            controller: ['$rootScope', '$scope', '$document', function ($rootScope, $scope, $document) {
                $scope.site = $rootScope.site;
            }],
            template: '<div class="aqua-newspage" ui-view></div>'
        })
        .state('newslist', {
            parent: 'news',
            url: '/' + urls.news.fr, // TODO : when multilang, change this to something dynamic
            controller: ['$scope', '$rootScope', 'drupal', '$state', '$filter', 'headermanager', 'tools', function ($scope, $rootScope, drupal, $state, $filter, $headermanager, tools) {

                $scope.loading = true;

                $headermanager.customize({
                    filled: true
                });

                $scope.canLoadMore = true;
                $scope.currentPage = 0;
                $scope.list = [];
                $scope.limit = 5;
                $scope.step = 5;
                $scope.site.id = $rootScope.site.id;

                $scope.labeldisplaymore = tools.replace($filter('translate')('news.moreNews'), { number: $scope.step });
                $scope.labelempty = $filter('translate')('news.empty');

                // build  breadcrumb
                $scope.breadcrumb = [
                    { label: $filter('translate')('home'), state: 'homepage' }
                ];

                if ($rootScope.site.id === 'avenir') {
                    // get page info
                    drupal.getPage('news').then(function (page) {
                        if (!page) {
                            $state.go('404');
                        } else {
                            $scope.title = page.title;
                            // $scope.breadcrumb.push({label: page.title});
                            $scope.widgets = page.field_widgets;
                        }
                    });
                } else {
                    // page information is retrieved from config
                    $scope.config = $rootScope.config.site;
                }
                var configSiteNewsWatcher = $rootScope.$watch('config.site.news.seo', function (config) {
                    if (config) {
                        if (config.keywords) {
                            tools.setMetaValue('keywords', config.keywords);
                        }
                        if (config.description) {
                            tools.setMetaValue('description', config.description);
                        }
                    }
                });

                $scope.$on('$destroy', function () {
                    configSiteNewsWatcher();
                });

                $scope.loadMoreNews = function() {
                    $scope.currentPage++;
                    $scope.limit += $scope.step;
                    loadNews();
                };

                function loadNews() {
                    drupal.getNews($scope.currentPage, $scope.step, $scope.site.id).then(function (news) {
                        $scope.labelmore = $filter('translate')('news.more');
                        var newArticles = news.map(function (article) {
                            article.created = new Date(parseInt(article.created) * 1000);
                            article.state = 'newsdetail({id: ' + article.nid + ', slug: \'' + $filter('slugify')(article.title) + '\'})';
                            return article;
                        });
                        $scope.loading = false;
                        $scope.canLoadMore = news.length >= $scope.step;
                        $scope.list = $scope.list.concat(newArticles);
                    });
                }

                loadNews();
            }],
            templateUrl: 'src/views/news/news.html'
        })
        .state('newsdetail', {
            parent: 'news',
            url: '/' + urls.news.fr + '/{slug}--{id:int}', // TODO : when multilang, change this to something dynamic
            controller: ['$scope', '$rootScope', 'drupal', '$stateParams', '$state', '$filter', 'headermanager', '$location', 'tools',  function ($scope, $rootScope, drupal, $stateParams, $state, $filter, $headermanager, $location, tools) {
                $scope.loading = true;
                $scope.configSite = $rootScope.config.site;

                $scope.pageUrl = $location.absUrl();

                $scope.tools = tools;

                $headermanager.customize({
                    filled: true
                });

                // build  breadcrumb
                $scope.breadcrumb = [
                    { label: $filter('translate')('home'), state: 'homepage' },
                    { label: $filter('translate')('news.title'), state: 'newslist' }
                ];
                // get detail node
                drupal.getNode($stateParams.id).then(function (page) {
                    if (!page || page.status !== '1') {
                        // page not found
                        $state.go('404');

                    } else {
                        // page found
                        $scope.page = page;
                        // $scope.breadcrumb.push({label: page.title});
                        $scope.loading = false;
                    }
                });

            }],
            templateUrl: 'src/views/news/new.html'
        });
}]);
